import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "credit-card",
  "use": "credit-card-usage",
  "viewBox": "0 0 24 16",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" viewBox=\"0 0 24 16\" id=\"credit-card\"><defs><path id=\"credit-card_a\" d=\"M710 486h24v6a2 2 0 0 1-2 2h-20a2 2 0 0 1-2-2zm19 4a1 1 0 1 0 2 0 1 1 0 0 0-2 0m-3 0a1 1 0 1 0 2 0 1 1 0 0 0-2 0m-16-10c0-1.1.9-2 2-2h20a2 2 0 0 1 2 2v3h-24z\" /></defs><use xlink:href=\"#credit-card_a\" fill=\"#7e8fa5\" transform=\"translate(-710 -478)\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol